import { InjectionToken } from '@angular/core';

import { InitialLocation } from './initial_location';

export const INTEGRATIONS_FEATURE_FLAGS = new InjectionToken<Record<string, boolean>>(
  'integrations feature flags',
);
export const INITIAL_LOCATION = new InjectionToken<InitialLocation>('INITIAL_LOCATION');
